module.exports = __webpack_public_path__ + "img/Vector 28.10646ba0.png";